var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Model from 'models/Model';
import { DocumentLineGroupPaidFrom, DocumentLineGroupPaidOn } from 'models';
import { plainToInstance } from 'class-transformer';
var DocumentLineGroupMetaInfo = /** @class */ (function (_super) {
    __extends(DocumentLineGroupMetaInfo, _super);
    function DocumentLineGroupMetaInfo() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DocumentLineGroupMetaInfo.prototype.getPaidOnEntities = function () {
        return plainToInstance(DocumentLineGroupPaidOn, this.paid_on_entities);
    };
    DocumentLineGroupMetaInfo.prototype.getPaidFromEntities = function () {
        return plainToInstance(DocumentLineGroupPaidFrom, this.paid_from_entities);
    };
    return DocumentLineGroupMetaInfo;
}(Model));
export default DocumentLineGroupMetaInfo;
